import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";

import "./styles.css";
import { isAdminPath, publicRideSlug } from "./tracker";

/* Each route is a separate chunk. MapLibre GL is ~230 kB gzipped and only the
 * tracker needs it, so the admin page must not pay for it — and a viewer opening
 * a share link on a phone on mobile data must not download the admin page. */
const TrackerPage = lazy(async () => ({
  default: (await import("./TrackerPage")).TrackerPage,
}));
const AdminPage = lazy(async () => ({
  default: (await import("./AdminPage")).AdminPage,
}));

/** Routes, matched on the path rather than with a router dependency:
 *
 * - `/`              the dashboard for whichever race is current
 * - `/race/<slug>`   one specific race, shareable — the canonical form
 * - `/r/<slug>`      the same thing, kept working because links to it are
 *                    already in people's messages
 * - `/admin`         the operator page
 *
 * `/` renders the map itself rather than a page explaining where the map is:
 * opening the site should show the route and the wind, and the dashboard handles
 * the "nothing published yet" case with a panel pointing at admin.
 */
function App() {
  const path = window.location.pathname;
  const slug = publicRideSlug(path);

  if (isAdminPath(path)) {
    return (
      <Suspense fallback={<Loading />}>
        <AdminPage />
      </Suspense>
    );
  }
  return (
    <Suspense fallback={<Loading />}>
      <TrackerPage slug={slug ?? undefined} />
    </Suspense>
  );
}

function Loading() {
  return (
    <div className="admin admin--gate">
      <p className="meta">Loading&hellip;</p>
    </div>
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
